import Util from '../../forecast-app/shared/util/util';
export const CommitMutation = (mutationClass, input, onSuccess, retry = true, uploadables = null, onError) => {
    Util.CommitMutation(mutationClass, input, onSuccess, retry, uploadables, onError);
};
